export enum Countries {
  angola,
  botswana,
  mozambique,
  namibia,
  nigeria,
  southAfrica,
  uganda,
  zimbabwe,
  zambia,
  other,
}
